import { memo } from "react";

import Accessibility from "~public/icons/accessibility.svg";
import BagShopping from "~public/icons/agenda_categories/bag_shopping.svg";
import Bed from "~public/icons/agenda_categories/bed.svg";
import Bicycle from "~public/icons/agenda_categories/bicycle.svg";
import BuildingColumns from "~public/icons/agenda_categories/building_columns.svg";
import BuildingMuseum from "~public/icons/agenda_categories/building_museum.svg";
import Buste from "~public/icons/agenda_categories/buste.svg";
import CircleParking from "~public/icons/agenda_categories/circle_parking.svg";
import FerrisWheel from "~public/icons/agenda_categories/ferris_wheel.svg";
import FlagPennant from "~public/icons/agenda_categories/flag_pennant.svg";
import Gallery from "~public/icons/agenda_categories/gallery.svg";
import Key from "~public/icons/agenda_categories/key.svg";
import MapLocation from "~public/icons/agenda_categories/map_location.svg";
import MasksTheater from "~public/icons/agenda_categories/masks_theater.svg";
import MicrophoneStand from "~public/icons/agenda_categories/microphone_stand.svg";
import MugSaucer from "~public/icons/agenda_categories/mug_saucer.svg";
import PartyHorn from "~public/icons/agenda_categories/party_horn.svg";
import PlateUtensils from "~public/icons/agenda_categories/plate_utensils.svg";
import Ship from "~public/icons/agenda_categories/ship.svg";
import Shop from "~public/icons/agenda_categories/shop.svg";
import Store from "~public/icons/agenda_categories/store.svg";
import TentDoublePeak from "~public/icons/agenda_categories/tent_double_peak.svg";
import Tree from "~public/icons/agenda_categories/tree.svg";
import Utensils from "~public/icons/agenda_categories/utensils.svg";
import Windmill from "~public/icons/agenda_categories/windmill.svg";
import ArrowDownLight from "~public/icons/arrow-down-light.svg";
import ArrowDown from "~public/icons/arrow-down.svg";
import ArrowRight from "~public/icons/arrow-right.svg";
import ArrowsMaximize from "~public/icons/arrows-maximize.svg";
import Calendar from "~public/icons/calendar.svg";
import Check from "~public/icons/check.svg";
import ChevronDown from "~public/icons/chevron-down.svg";
import ChevronLeft from "~public/icons/chevron-left.svg";
import ChevronRight from "~public/icons/chevron-right.svg";
import ChevronUp from "~public/icons/chevron-up.svg";
import Clock from "~public/icons/clock.svg";
import Copy from "~public/icons/copy.svg";
import CreditCardLight from "~public/icons/credit-card-light.svg";
import CreditCard from "~public/icons/credit-card.svg";
import Cross from "~public/icons/cross.svg";
import Crowd from "~public/icons/crowd.svg";
import EditSquare from "~public/icons/edit-square.svg";
import Email from "~public/icons/email.svg";
import ExternalLink from "~public/icons/external-link.svg";
import Balloon from "~public/icons/fa/balloon.svg";
import Filter from "~public/icons/filter.svg";
import Filters from "~public/icons/filters.svg";
import Gear from "~public/icons/gear.svg";
import Gift from "~public/icons/gift.svg";
import HeartSolid from "~public/icons/heart-solid.svg";
import HeartOutline from "~public/icons/heart.svg";
import Home from "~public/icons/home.svg";
import House from "~public/icons/house.svg";
import InfoCircle from "~public/icons/info-circle.svg";
import Link from "~public/icons/link.svg";
import LocationNeedle from "~public/icons/location-needle.svg";
import LocationPin from "~public/icons/location-pin.svg";
import Logout from "~public/icons/logout.svg";
import MapWithoutPin from "~public/icons/map.svg";
import Map from "~public/icons/mapWithPin.svg";
import Min from "~public/icons/min.svg";
import MobilePhone from "~public/icons/mobile-phone.svg";
import Pause from "~public/icons/pause.svg";
import Phone from "~public/icons/phone.svg";
import Play from "~public/icons/play.svg";
import Plus from "~public/icons/plus.svg";
import Search from "~public/icons/search.svg";
import ShakeHands from "~public/icons/shake-hands.svg";
import Share from "~public/icons/share.svg";
import Ticket from "~public/icons/ticket.svg";
import Train from "~public/icons/train.svg";
import Trash from "~public/icons/trash.svg";
import UserCheck from "~public/icons/user-check.svg";
import UserCross from "~public/icons/user-cross.svg";

export const ICON_COMPONENTS = {
  accessibility: Accessibility,
  shoppingBag: BagShopping,
  bed: Bed,
  bicycle: Bicycle,
  buildingColumns: BuildingColumns,
  buildingMuseum: BuildingMuseum,
  buste: Buste,
  circleParking: CircleParking,
  ferrisWheel: FerrisWheel,
  flagPennant: FlagPennant,
  gallery: Gallery,
  key: Key,
  mapLocation: MapLocation,
  masksTheater: MasksTheater,
  microphoneStand: MicrophoneStand,
  mugSaucer: MugSaucer,
  partyHorn: PartyHorn,
  plateUtensils: PlateUtensils,
  ship: Ship,
  shop: Shop,
  store: Store,
  tentDoublePeak: TentDoublePeak,
  tree: Tree,
  utensils: Utensils,
  windmill: Windmill,
  arrowDownLight: ArrowDownLight,
  arrowDown: ArrowDown,
  arrowRight: ArrowRight,
  arrowsMaximize: ArrowsMaximize,
  calendar: Calendar,
  check: Check,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  clock: Clock,
  copy: Copy,
  creditCardLight: CreditCardLight,
  cross: Cross,
  crowd: Crowd,
  editSquare: EditSquare,
  email: Email,
  externalLink: ExternalLink,
  balloon: Balloon,
  filter: Filter,
  filters: Filters,
  gift: Gift,
  heartOutline: HeartOutline,
  heartSolid: HeartSolid,
  home: Home,
  house: House,
  infoCircle: InfoCircle,
  link: Link,
  locationNeedle: LocationNeedle,
  locationPin: LocationPin,
  mapWithoutPin: MapWithoutPin,
  map: Map,
  min: Min,
  mobile_phone: MobilePhone,
  pause: Pause,
  phone: Phone,
  play: Play,
  plus: Plus,
  shakeHands: ShakeHands,
  share: Share,
  ticket: Ticket,
  train: Train,
  trash: Trash,
  creditCard: CreditCard,
  userCheck: UserCheck,
  userCross: UserCross,
  gear: Gear,
  logout: Logout,
  search: Search,
} as const;

export type IconName = keyof typeof ICON_COMPONENTS;

export interface IconProps {
  name: IconName;
  label?: string;
  className?: string;
  iconClassName?: string;
}

const Icon: React.FC<IconProps> = memo(
  ({ name, label, className, iconClassName }) => {
    const IconComponent = ICON_COMPONENTS[name];

    const svgElement = (
      <IconComponent
        focusable="false"
        aria-hidden="true"
        className={iconClassName}
      />
    );

    return label ? (
      <span className={className}>
        {svgElement}
        <span className="sr-only">{label}</span>
      </span>
    ) : (
      svgElement
    );
  },
);

Icon.displayName = "Icon";

export default Icon;
